import { Text } from '@mantine/core';

export function FeedbackThankYouPage(): JSX.Element {
  return (
    <Text mt={10} size={'xl'} mb={'lg'} color={'gray.6'} fw={700}>
      Thank you for your feedback!
    </Text>
  );
}
